// src/data/hot-search-data.js

// 公共热搜词数据（默认静态数据，后续可替换为接口返回的动态数据）
let hotSearchData = {
  // 公共热搜词（placeholder 轮播、popular-tags 共用）
  common: [
    '秋冬羽绒服', '无线蓝牙耳机', '平价粉底液', '加绒牛仔裤',
    '智能家居', '考研真题', '儿童绘本', '保温杯',
    '苹果17 Pro', '华为Mate80', 'Nike运动鞋', '海底捞火锅券'
  ],
  // 可选：小屏专属简短热搜词（如需区分，可保留；无需区分则删除，直接用 common）
  smallScreen: [
    '羽绒服', '蓝牙耳机', '粉底液', '牛仔裤',
    '智能家居', '考研真题', '儿童绘本', '保温杯'
  ]
}

//  对外暴露方法：获取热搜词（支持区分大屏/小屏）
export const getHotSearchTags = (type = 'common') => {
  // type 可选值：'common'（默认，公共全部）、'smallScreen'（小屏简短）
  return hotSearchData[type] || hotSearchData.common
}

//  对外暴露方法：更新热搜词（后续接口获取数据后，调用此方法更新）
export const updateHotSearchTags = (newData, type = 'common') => {
  // newData：接口返回的新热搜词数组（如 [ '新热搜1', '新热搜2' ]）
  if (Array.isArray(newData) && newData.length > 0) {
    hotSearchData[type] = newData
  }
  // 返回更新后的数据，方便链式调用
  return hotSearchData[type]
}

// 对外暴露原始数据（可选，如需直接操作数据）
export const hotSearchRawData = hotSearchData
